import * as helpers from "./helpers";
import { isIdCorrect } from "../account-generator";
import { getType } from "./actions";

let isValid = true;
let firstWrongField = null;

const resetValidation = () => {
  isValid = true;
  firstWrongField = null;
}

const checkStringStartsWithSpace = value => /^\s/.test(value);

const handleError = (message = '', field) => {
  helpers.error(message, field.name);
  isValid = false;
  if (!firstWrongField) firstWrongField = field;
}

const validate = (form, fieldName = '') => {
  resetValidation();

  if (!fieldName) helpers.resetErrors(form);

  const dataType = form.querySelector('button[data-type].active');
  if (dataType) {
    const type = dataType.getAttribute('data-type');
    const fields = form.querySelectorAll(`#${type} input`);

    if (fields.length > 0) {
      fields.forEach(field => {
        if ((field.name == 'customer_first_name' && !fieldName) ||
          (field.name === "customer_first_name" && fieldName === "customer_first_name")) {

          if (fieldName) helpers.resetError(field.name);
          if (/^(?![a-zęóąśłżźćń]+$)/i.test(field.value)) {
            handleError('Błędne imię', field);
          }

        }
        else if ((field.name == 'customer_last_name' && !fieldName) ||
          (field.name === "customer_last_name" && fieldName === "customer_last_name")) {

          if (fieldName) helpers.resetError(field.name);
          if (/^(?![a-zęóąśłżźćń]+(-[a-zęóąśłżźćń]+)?$)/i.test(field.value)) {
            handleError('Błędne nazwisko', field);
          }

        }
        else if ((field.name == 'company_name' && !fieldName) ||
          (field.name === "company_name" && fieldName === "company_name")) {

          if (fieldName) helpers.resetError(field.name);
          console.log('checkStringStartsWithSpace', checkStringStartsWithSpace(field.value))

          if (checkStringStartsWithSpace(field.value)) {
            handleError('Nazwa firmy nie może zaczynać się od spacji', field);
          }

          if (/^(?![a-zęóąśłżźćń0-9\-\.\,\s]+$)/i.test(field.value)) {
            handleError('Błędna nazwa firmy', field);
          }

        }
      });
    }
  }

  if (!fieldName || fieldName == "customer_email") {
    const email = form.querySelector('[name="customer_email"]');

    if (fieldName) helpers.resetError(email.name);
    if (/^(?!\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$)/.test(email.value)) {
      handleError('Błędny adres e-mail', email);
    }
  }

  if (!fieldName || fieldName == "tax_country") {
    const country = form.querySelector('[name="tax_country"]');

    if (fieldName) helpers.resetError(country.name);
    if (/^(?![a-zęóąśłżźćń0-9\-]+$)/i.test(country.value)) {
      handleError('Błędna nazwa kraju', country);
    }
  }

  if (!fieldName || fieldName == "street") {
    const street = form.querySelector('[name="street"]');

    if (fieldName) helpers.resetError(street.name);

    if (checkStringStartsWithSpace(street.value))
      handleError('Błędna nazwa ulicy', street);

    if (/^(?![a-zęóąśłżźćń0-9\-\.\,\s]+$)/i.test(street.value)) {
      handleError('Błędna nazwa ulicy', street);
    }
  }

  if (!fieldName || fieldName == "street_house_no") {
    const streetHouseNo = form.querySelector('[name="street_house_no"]');

    if (fieldName) helpers.resetError(streetHouseNo.name);
    if (/^(?!\d+[a-zA-Z]?$)/.test(streetHouseNo.value)) {
      handleError('Błędny numer', streetHouseNo);
    }
  }

  if (!fieldName || fieldName == "street_staircase_no") {
    const streetStaicaseNo = form.querySelector('[name="street_staircase_no"]');

    if (fieldName) helpers.resetError(streetStaicaseNo.name);
    if (streetStaicaseNo.value != '' && /^(?!\d+[a-zA-Z]?$)/.test(streetStaicaseNo.value)) {
      handleError('Błędny numer', streetStaicaseNo);
    }
  }

  if (!fieldName || fieldName == "city") {
    const city = form.querySelector('[name="city"]');

    if (fieldName) helpers.resetError(city.name);

    if (checkStringStartsWithSpace(city.value)) handleError('Błędna nazwa', city);

    if (/^(?![a-zęóąśłżźćń\-\.\,\s\d]+$)/i.test(city.value)) {
      handleError('Błędna nazwa', city);
    }
  }

  if (!fieldName || fieldName == "postal_code") {
    const postalCode = form.querySelector('[name="postal_code"]');

    if (fieldName) helpers.resetError(postalCode.name);
    if (/^(?![\d\-]+$)/i.test(postalCode.value)) {
      handleError('Błędny kod', postalCode);
    }
  }

  if (!fieldName || fieldName == "document_type") {
    const documentType = form.querySelector('[name="document_type"]');

    if (fieldName) helpers.resetError(documentType.name);
    if (documentType.value === '') {
      handleError('Błędny typ', documentType);
    }
  }

  if (!fieldName || fieldName == "period_year") {
    const periodYear = form.querySelector('[name="period_year"]');

    if (fieldName) helpers.resetError(periodYear.name);
    if (periodYear.value === '') {
      handleError('Błędny rok', periodYear);
    }
  }

  if (!fieldName || fieldName == "period_type") {
    const periodType = form.querySelector('[name="period_type"]');

    if (fieldName) helpers.resetError(periodType.name);
    if (periodType.value === '') {
      handleError('Błędny okres', periodType);
    }
  }

  if (!fieldName || fieldName == "period_no") {
    const periodNo = form.querySelector('[name="period_no"]');
    const periodType = form.querySelector('[name="period_type"]');

    if (fieldName) helpers.resetError(periodNo.name);
    if (periodNo.value != '' ||
      (periodType.value != 'R' && periodType.value != '0')) {

      if (/^(?![\d]+$)/i.test(periodNo.value)) {
        handleError('Błędny okres', periodNo);
      }

    }
  }

  if (!fieldName || fieldName == "tax_amount") {
    const taxAmount = form.querySelector('[name="tax_amount"]');

    if (fieldName) helpers.resetError(taxAmount.name);
    if (!/^\d+(?:[.,]\d{1,2}|$)$/.test(taxAmount.value)) {
      handleError('Błędna kwota', taxAmount);
    }
    if (/^[\d\,\.]+$/.test(taxAmount.value) && (parseFloat(taxAmount.value.replace(',', '.')) > parseFloat('4300.00'))) {
      handleError('Kwota maksymalna to 4300 zł', taxAmount);
    }
  }

  if (!fieldName || (fieldName == "pesel" || fieldName == "nip")) {
    const field = form.querySelector('.id-data input');
    if (!field) return false;

    if (fieldName) helpers.resetError(field.name);

    const type = getType();
    if (!isIdCorrect(type.id, field.value)) {
      helpers.error('Niepoprawny numer identyfikatora', type.label.toLowerCase());
      isValid = false;
      if (!firstWrongField) firstWrongField = field;
      // handleError('Niepoprawny numer identyfikatora', field);
    }
  }

  if (!isValid && firstWrongField) firstWrongField.scrollIntoView({ behavior: "smooth", block: "center" });

  return isValid;
};

export default validate;